<template>
  <div>
    <img
      :class="coverImage ? 'image-container' : 'image-container-logo'"
      ref="image"
      :src="src"
    />
    <!-- <img :src="this.destination" > -->
  </div>
</template>

<script>
import Cropper from "cropperjs";
export default {
  name: "imageCropper",
  props: {
    src: String,
    coverImage: Boolean,
    logoImage: Boolean,
  },
  data() {
    return {
      cropper: {},
      destination: {},
      image: {},
    };
  },

  mounted() {
    this.image = this.$refs.image;
    this.cropper = new Cropper(this.image, {
      scalable: false,
      zoomable: false,
      aspectRatio: this.coverImage ? 4 / 1 : 1,

      crop: () => {
        const canvas = this.cropper.getCroppedCanvas();
        this.destination = canvas.toDataURL("image/png");
        if (this.coverImage) {
          this.$emit("cropImageData", this.destination);
        } else {
          this.$emit("cropLogoImageData", this.destination);
        }
      },
    });
  },
};
</script>

<style scoped lang="scss">
.image-container {
  width: 1000px;
  height: 300px;
  object-fit: none;
}
.image-container-logo {
  width: 400px;
  height: 150px;
  object-fit: none;
}
</style>
